<template>
  <div>
    <vue-excel-xlsx
      :data="data"
      :columns="columns"
      :filename="'extintores'"
      :sheetname="'sheetname'"
      v-if="controlerBtnSubmit == true"
      class="btn btn-primary"
    >
      Extintores
    </vue-excel-xlsx>
    <button type="button" class="btn btn-primary" disabled v-else>
      <i class="fa fa-refresh fa-spin"></i> Carregando Extintores...
    </button>
  </div>
</template>

<script>
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
Vue.use(VueExcelXlsx);

export default {
  // lista de franquias passada pelo componente Index
  // variavel que irá armazenar os dados que serão exportados para planilha Excel
  data() {
    return {
      env: process.env,
      franquias: [],
      controlerBtnSubmit: false,
      // colunas para composição da planilha Excel
      columns: [
        {
          label: "N° Preventiva",
          field: "preventiva_id",
        },
        {
          label: "UF",
          field: "uf",
        },
        {
          label: "Gram",
          field: "gram",
        },
        {
          label: "Gram Atendimento",
          field: "gram_atendimento",
        },
        {
          label: "Sigla",
          field: "sigla",
        },
        {
          label: "Sigla Op.",
          field: "sigla_operacao",
        },
        {
          label: "Código Imóvel",
          field: "codigo_imovel",
        },
        {
          label: "Tipo de Imóvel",
          field: "tipo_imovel_contrato",
        },
        {
          label: "Qtd de Extintores",
          field: "quantidade",
        },
        {
          label: "Tipo",
          field: "tipo",
        },
        {
          label: "Tamanho",
          field: "tamanho",
        },
        {
          label: "Descrição",
          field: "descricao",
        },
        {
          label: "Data de Vencimento",
          field: "data_vencimento",
        },
        {
          label: "Data Programada",
          field: "data_programada",
        },
        {
          label: "Data de Execução",
          field: "data_execucao",
        },
        {
          label: "Atualizado em",
          field: "atualizado_em",
        },
      ],
    };
  },
  mounted: function () {
    this.planilhaExtintores();
  },
  methods: {
    planilhaExtintores() {
      let vm = this;

      this.$axios
        .get(`${this.env.FINANCEIRO.SLA}/getExtintores`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.login.loginUsuario.token}`,
          },
        })
        .then(function (response) {
          vm.extintores = vm.formatarDados(response.data);
          vm.data = vm.extintores;
          vm.controlerBtnSubmit = true;
        });
    },
    priceFormat(value) {
      return "R$ " + value;
    },
    // função para formatar os dados da lista de franquias e adcionálos ao array que irá preencher a planilha Excel
    formatarDados(dados) {
      dados.forEach(element => {
        element.data_vencimento = this.formataDataBrasil(element.data_vencimento)
        element.data_execucao = this.formataDataBrasil(element.data_execucao)
        element.data_programada = this.formataDataBrasil(element.data_programada)
        element.atualizado_em = this.formataDataHoraBrasil(element.atualizado_em)
      });
      return dados
    },
    formataDataBrasil: function (dataForm) {
      if (dataForm !== "" && dataForm !== undefined && dataForm !== null) {
        let dataHoraAntigaSeparada = dataForm.split(" ");
        let dataSeparada = dataHoraAntigaSeparada[0].split("-");
        return `${dataSeparada[2]}/${dataSeparada[1]}/${dataSeparada[0]}`;
      }
      return dataForm;
    },
    formataDataHoraBrasil: function (dataForm) {
      if (dataForm !== "" && dataForm !== undefined && dataForm !== null) {
        let dataHoraAntigaSeparada = dataForm.split(" ");
        let dataSeparada = dataHoraAntigaSeparada[0].split("-");
        return `${dataSeparada[2]}/${dataSeparada[1]}/${dataSeparada[0]} ${dataHoraAntigaSeparada[1]}`;
      }
      return dataForm;
    },
  },
};
</script>

<style scoped>
button:hover {
  background-color: #6c757d;
}

/* button {
  background-color: #3c7fe4;
  color: white;
  margin: 1%;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 5px;
  padding-top: 5px;
  border-style: none;
  border-radius: 5px;
  width: 160px;
  height: 50px;
} */
</style>



// WEBPACK FOOTER //
// ExportExtintores.vue?7102b926